import React, { useState } from 'react';
import axios from 'axios';
import { useLocation, Redirect, Link } from 'react-router-dom';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function ResetPasswordB2B() {
  const q = useQuery();
  const token = q.get('token') || '';
  const email = q.get('email') || '';

  const [newPassword, setNewPassword] = useState('');
  const [newPassword2, setNewPassword2] = useState('');
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setError('');

    if (!token || !email) {
      setError('Lien invalide.');
      return;
    }
    if (newPassword.length < 8) {
      setError('Mot de passe: minimum 8 caractères.');
      return;
    }
    if (newPassword !== newPassword2) {
      setError('Les mots de passe ne correspondent pas.');
      return;
    }

    setLoading(true);
    try {
      await axios.post('/api/b2b/reset-password', { email, token, newPassword });
      setDone(true);
    } catch (err) {
      setError(err.response?.data?.message || 'Erreur lors de la réinitialisation.');
    } finally {
      setLoading(false);
    }
  };

  if (done) return <Redirect to="/b2b-login" />;

  return (
    <div className="d-flex justify-content-center" style={{ marginTop: '6rem' }}>
      <form onSubmit={submit} className="form-group">
        <h3>Nouveau mot de passe</h3>

        <input type="email" value={email} readOnly className="mb-2" />

        <input
          type="password"
          placeholder="Nouveau mot de passe (min 8)"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          required
          className="mb-2"
        />
        <input
          type="password"
          placeholder="Confirmer le mot de passe"
          value={newPassword2}
          onChange={(e) => setNewPassword2(e.target.value)}
          required
        />

        {error ? <p style={{ color: 'red' }}>{error}</p> : null}

        <button type="submit" disabled={loading} className="submit-btn mt-2">
          {loading ? 'Mise à jour...' : 'Mettre à jour'}
        </button>

        <div style={{ marginTop: 10 }}>
          <Link to="/b2b-login">Retour connexion</Link>
        </div>
      </form>
    </div>
  );
}
